import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routing from "./routes";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";
import defaultTheme from "./assets/themes/default-theme.json";
import { Provider } from "react-redux";
import store from "./store";
import MessageProvider from "./base/MessageProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import NotificationHandler from "./base/NotificationHandler";
import packageFiles from "../package.json";
import { StorageConstants } from "./admin/storage/storageConstants";

export const UserContext = createContext();

const Theme = responsiveFontSizes(createTheme(defaultTheme));

function App() {
  const [user, setUser] = useState({ loggedIn: false });
  const [loginTime, setLoginTime] = useState({ loginTime: "" });

  const { version } = packageFiles; // Get current app version

  // console.log("🔄 App Initialization >>>>", {
  //   environment: process.env.NODE_ENV,
  //   appVersion: version,
  //   publicUrl: process.env.PUBLIC_URL,
  // });

  useEffect(() => {
    const storedVersion = localStorage.getItem(StorageConstants.APP_VERSION);

    if (!storedVersion) {
      localStorage.setItem(StorageConstants.APP_VERSION, version);
    }

    // Start Worker for Auto-Reloading
    if (window.Worker) {
      const worker = new Worker("/versionWorker.js");

      // Send current app version to worker
      worker.postMessage({ type: "SET_VERSION", version });

      // Handle messages from worker
      worker.onmessage = (event) => {
        if (event.data.type === "NEW_VERSION") {
          const storedVersion = localStorage.getItem(
            StorageConstants.APP_VERSION
          );

          if (storedVersion !== event.data.version) {
            alert("A new version is available! Reloading...");

            localStorage.setItem(
              StorageConstants.APP_VERSION,
              event.data.version
            );
            window.location.reload();
          }
        }
      };

      return () => {
        worker.terminate();
      };
    } else {
      console.warn("Web Workers are not supported in this browser.");
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Provider store={store}>
        <MessageProvider>
          <NotificationHandler>
            <ThemeProvider theme={Theme}>
              <UserContext.Provider
                value={{ user, setUser, loginTime, setLoginTime }}
              >
                <BrowserRouter>
                  <Routing />
                </BrowserRouter>
              </UserContext.Provider>
            </ThemeProvider>
          </NotificationHandler>
        </MessageProvider>
      </Provider>
    </LocalizationProvider>
  );
}

export default App;
